import { exhaustiveCheck } from '@/utils/exhaustive-check';
import { AccountType, PaymentDestinationType } from '@seapoint/server/enums';

export const getPaymentDestinationType = (sourceAccountType: AccountType) => {
  switch (sourceAccountType) {
    case AccountType.BANKING:
      return PaymentDestinationType.ACCOUNT;
    case AccountType.INVESTMENT:
      return PaymentDestinationType.TREASURY;
    default:
      return exhaustiveCheck(sourceAccountType);
  }
};
